const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function plural(n: number, noun: string): string {
  return `${n} ${noun}${n === 1 ? "" : "s"}`;
}

export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || Number.isNaN(ms)) return "—";
  if (ms === 0) return "0s";
  if (ms < 1_000) return "<1s";
  const totalSec = Math.floor(ms / 1_000);
  const h = Math.floor(totalSec / 3_600);
  const m = Math.floor((totalSec % 3_600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export function formatBytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(1)} ${units[i]}`;
}

export function shortSha(sha: string): string {
  return sha.slice(0, 12);
}

function pad(n: number) {
  return String(n).padStart(2, "0");
}

function parts(d: Date, zone: "local" | "utc") {
  return zone === "utc"
    ? { y: d.getUTCFullYear(), mo: d.getUTCMonth(), day: d.getUTCDate(), h: d.getUTCHours(), mi: d.getUTCMinutes(), s: d.getUTCSeconds() }
    : { y: d.getFullYear(), mo: d.getMonth(), day: d.getDate(), h: d.getHours(), mi: d.getMinutes(), s: d.getSeconds() };
}

export function formatAbsolute(iso: string, zone: "local" | "utc"): string {
  const p = parts(new Date(iso), zone);
  const base = `${p.day} ${MONTHS[p.mo]} ${p.y}, ${pad(p.h)}:${pad(p.mi)}:${pad(p.s)}`;
  return zone === "utc" ? `${base} UTC` : base;
}

export function formatClock(iso: string, zone: "local" | "utc"): string {
  const p = parts(new Date(iso), zone);
  return `${pad(p.h)}:${pad(p.mi)}:${pad(p.s)}`;
}

export function formatRelative(iso: string, now: number = Date.now()): string {
  const t = Date.parse(iso);
  const diff = now - t;
  const future = diff < 0;
  const abs = Math.abs(diff);
  const min = Math.round(abs / 60_000);
  const say = (v: number, unit: string) => (future ? `in ${v} ${unit}` : `${v} ${unit} ago`);
  if (abs < 45_000) return "just now";
  if (abs < 3_600_000) return say(Math.max(1, min), "min");
  if (abs < 86_400_000) return say(Math.round(abs / 3_600_000), "h");
  if (abs < 30 * 86_400_000) return say(Math.round(abs / 86_400_000), "d");
  const d = new Date(t);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}
